import React, { Fragment, useState } from "react";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import { motion, Reorder } from "framer-motion";
import {
  patchGamePopulousCites,
  populousCitesGameCompleted,
} from "../../actions/game.action";
import { toast } from "react-toastify";
import CityDragCard from "../gadgets/CityDragCard";

import { useTranslation } from "react-i18next";
import SwitchButton from "../buttons/SwitchButton";
import CityCardLabel from "../gadgets/CityCardLabel";
import RippleButton from "../buttons/RippleButton";

const PopulousCitiesPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { countryOfToday } = useSelector(({ game }) => game);
  const { completed, guesses } = useSelector(({ game }) => game.populousCites);

  const [showAnswer, setShowAnswer] = useState(false);

  const handleGuess = () => {
    const isCorrect = countryOfToday?.cities?.reduce(
      (prev, city, idx) => prev && city.name === guesses[idx],
      true,
    );
    if (isCorrect) {
      toast.success(t("Congratulations!"));
    }
    dispatch(populousCitesGameCompleted());
  };

  return (
    <Fragment>
      <span
        className={`relative mt-6 flex w-full flex-row items-center justify-start font-bold text-slate-800 dark:text-slate-100 `}
      >
        <ReactSVG className="mr-2 w-24" src="/images/people.svg" />
        {t(`Arrange the cities in order to the population.`)}
      </span>
      <div className={`my-4 flex w-full flex-row`}>
        <div>
          {countryOfToday?.cities?.map((city, idx) => (
            <motion.div
              initial={{ opacity: 0, translateX: -100 }}
              animate={{ opacity: 1, translateX: 0 }}
              transition={{ delay: idx * 0.1 }}
              key={`city-label-${city?.name}`}
              className=" h-12 "
            >
              <CityCardLabel
                index={idx}
                value={city.population}
                max={countryOfToday?.cities[0].population}
              />
            </motion.div>
          ))}
        </div>
        <div className="my-0.5 grow">
          <Reorder.Group
            axis="y"
            onReorder={(nextGuesses) => {
              dispatch(
                patchGamePopulousCites({
                  guesses: nextGuesses,
                }),
              );
            }}
            values={guesses}
          >
            {guesses.map((city, idx) => (
              <motion.div
                initial={{ opacity: 0, translateX: 100 }}
                animate={{ opacity: 1, translateX: 0 }}
                transition={{ delay: idx * 0.1 }}
                key={`city-item-${city}`}
                className=" h-12 "
              >
                <Reorder.Item value={city} id={city}>
                  <CityDragCard
                    cityName={city}
                    completed={completed}
                    correctAnswer={countryOfToday?.cities[idx]}
                    showAnswer={showAnswer}
                  />
                </Reorder.Item>
              </motion.div>
            ))}
          </Reorder.Group>
        </div>
      </div>
      {!completed ? (
        <RippleButton
          className={`text-md flex h-10 w-full items-center justify-center rounded-lg bg-majky-600 px-8 py-1 font-semibold text-white hover:bg-majky-700 active:bg-majky-700  md:w-fit`}
          onClick={handleGuess}
        >
          <span>{t("Guess")}</span>
        </RippleButton>
      ) : (
        <div className="flex px-4 py-2">
          <label className="mr-4 flex-1" htmlFor="switch-showAnswer">
            {t("Show Answer")}:
          </label>
          <SwitchButton
            id="switch-showAnswer"
            onChange={(e) => {
              setShowAnswer((prev) => !prev);
            }}
            checked={showAnswer}
          />
        </div>
      )}
    </Fragment>
  );
};

export default PopulousCitiesPage;
